import { createSelector } from '@reduxjs/toolkit';

//📌 Selector devices maintenance data from current profile
export const selectMaintenanceLogs = createSelector(
	[(state) => state.Maintenance.data, (state) => state.Auth.selectedProfile.orgID],
	(maintenanceData, orgID) => maintenanceData[orgID] || []
);

//📌 Selector devices maintenance data and loading from current profile
export const selectMaintenanceLogsAndLoading = createSelector(
	[
		(state) => state.Maintenance.data,
		(state) => state.Maintenance.loading,
		(state) => state.Auth.selectedProfile.orgID
	],
	(maintenanceData, loading, orgID) => ({ maintenanceData: maintenanceData[orgID] || [], loading })
);

// 📌 **Selector: Maintenance Logs with Category & Device Names**
export const selectEnrichedMaintenanceLogs = createSelector(
	[
		(state) => state.Maintenance.data,
		(state) => state.Maintenance.loading,
		(state) => state.Devices.data,
		(state) => state.Categories.data,
		(state) => state.Auth.selectedProfile.orgID
	],
	(maintenanceData, maintenanceLoading, devicesData, categoriesData, orgID) => {
		const maintenanceLogs = maintenanceData[orgID] || [];

		// Return `null` if there are no maintenance logs
		if (!maintenanceLogs.length) {
			return { data: [], loading: maintenanceLoading };
		}

		const devices = devicesData[orgID] || [];
		const categories = categoriesData[orgID] || [];

		// Merge maintenance logs with device and category names
		const enrichedLogs = maintenanceLogs.map((log) => {
			const device = devices.find((d) => d.deviceID === log.deviceID) || {};
			const category = categories.find((c) => c.categoryID === log.categoryID) || {};

			return {
				...log,
				deviceName: device.name || 'Unknown Device',
				categoryName: category.name || 'Unknown Category'
			};
		});

		return {
			data: enrichedLogs,
			loading: maintenanceLoading
		};
	}
);
